import { IMapper, setDateFromStorage } from '@fareye/common'
import { Card, Flex, IRenderControl, Label, RenderControl } from '@fareye/ui'
import queryString, { ParsedQuery } from 'query-string'
import React from 'react'
import { TOKEN_KEY } from '../../config/app'
import KpiGraph from './KpiGraph'
import OverviewPerformanceCards from './OverviewPerformanceCards'
import { cancelToken, get, parseJwt } from '@fareye/utils'
import { HEADER_INFLECTION, IN_PLANT } from '../../config/constants'
import {
  PerformanceCardsContainer,
  DashboardContainer
} from '../../style/styled'

const initialState = {
  data: null,
  isLoading: false,
  isSuccess: true,
  message: '',
  isError: false
}
export default function Dashboard(props: IMapper) {
  const { location, baseUrl } = props
  const isInplantRoutes = Boolean(localStorage.getItem(IN_PLANT) || '')
  const rawToken = JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}').token
  const userName: string = (rawToken && parseJwt(rawToken)?.name) || ''
  const searchParams: ParsedQuery<string | Date> = queryString.parse(
    location.search
  )
  const source = cancelToken().source()
  const [dateRange, setDateRange] = React.useState(() => {
    return setDateFromStorage({
      showDatePicker: true,
      carryDate: true,
      searchParams,
      daysDiff: 7
    })
  })
  const [performanceData, setPerformanceData] = React.useState<IRenderControl>(
    initialState
  )
  React.useEffect(() => {
    fetchPerformanceData()
  }, [])

  async function fetchPerformanceData() {
    try {
      setPerformanceData({ ...performanceData, isLoading: true })
      const {
        data: { content }
      } = await get(
        `${baseUrl}/api/v2/dashboard`,
        source.token,
        HEADER_INFLECTION
      )
      setPerformanceData({
        ...performanceData,
        isLoading: false,
        data: content,
        isSuccess: true,
        isError: false
      })
    } catch (ex) {
      setPerformanceData({
        ...performanceData,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: 'Something went wrong...'
      })
      console.error(ex)
    }
  }
  const { data } = performanceData
  return (
    <DashboardContainer>
      <Flex column>
        <Label variant="h3">Hello {userName}</Label>
        <Label variant="h6" style={{ padding: '10px 0' }}>
          Here are your updates for today!
        </Label>
      </Flex>
      <RenderControl state={performanceData}>
        {data && (
          <PerformanceCardsContainer>
            <OverviewPerformanceCards
              style={{ gridArea: 'card-1' }}
              {...data.activeTrips}
              urlLabel="View Dashboard"
              url="/in-transit/eta"
            />
            <OverviewPerformanceCards
              style={{ gridArea: 'card-11' }}
              {...data.totalInvoiceQuantity}
              urlLabel="View Dashboard"
              url="/in-transit/eta"
            />
            <OverviewPerformanceCards
              style={{ gridArea: 'card-2' }}
              {...data.delayedTrips}
              urlLabel="View Report"
              url="/in-transit/eta?status=delayed"
            />
            <OverviewPerformanceCards
              style={{ gridArea: 'card-22' }}
              {...data.delayedInvoiceQuantity}
              urlLabel="View Report"
              url="/in-transit/eta?status=delayed"
            />
            <OverviewPerformanceCards
              style={{ gridArea: 'card-3' }}
              {...data.tripsExceptionCount}
              urlLabel="View Report"
              url="/alert/report"
            />
            <Card style={{ gridArea: 'graph' }}>
              <KpiGraph baseUrl={baseUrl} dateRange={dateRange} />
            </Card>
            {isInplantRoutes && (
              <OverviewPerformanceCards
                {...data.vehiclesInPlant}
                urlLabel="View Report"
                url="/in-plant/map"
                style={{ gridArea: 'card-4' }}
              />
            )}
            <OverviewPerformanceCards
              {...data.tripsTrackingCompliance}
              count={
                data.tripsTrackingCompliance?.count
                  ? `${data.tripsTrackingCompliance?.count}%`
                  : ''
              }
              style={{ gridArea: isInplantRoutes ? 'card-5' : 'card-4' }}
            />
            <OverviewPerformanceCards
              label="Vendor Performance"
              urlLabel="View Report"
              url="/in-transit/transporters"
              showCount={false}
              style={{ gridArea: isInplantRoutes ? 'card-6' : 'card-5' }}
            />
            <OverviewPerformanceCards
              label="Route Performance"
              urlLabel="View Report"
              url="/in-transit"
              showCount={false}
              style={{ gridArea: isInplantRoutes ? 'card-7' : 'card-6' }}
            />
          </PerformanceCardsContainer>
        )}
      </RenderControl>
    </DashboardContainer>
  )
}
